import Headroom from "headroom.js";

var headerElement = document.querySelector("header");
var headroom  = new Headroom(headerElement, {
  offset: 0
});
headroom.init();